
import { defineComponent } from 'vue'

import IntegrationsDetailMixin from '~/mixins/integrationsDetailMixin'

export default defineComponent({
  name: 'EventAlertsSection',
  mixins: [IntegrationsDetailMixin]
})
